import React from 'react';

import { tracker } from '@femtasy/helpers';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useAuth } from 'hooks/useAuth';
import { useIsPWA } from 'hooks/useIsPWA';
import useStaticValues from 'hooks/useStaticValues';
import {
  pushInstruction,
  trackSiteSearch,
} from 'hooks/useTracking';

import { SearchState } from 'store/modules/search';
import ReduxState from 'store/ReduxState';

const PRODUCTION_SITE_ID = 1;
const STAGING_SITE_ID = 2;

export const getSiteId = () => {
  return process.env.IS_PRODUCTION === 'true'
    ? PRODUCTION_SITE_ID
    : STAGING_SITE_ID;
};

export const MatomoTracker = () => {
  const { user } = useAuth();

  const { searchTerm, searchResults } = useSelector<ReduxState, SearchState>(
    ({ search }) => search,
  );

  const location = useLocation();
  const { matomoCustomDimensions } = useStaticValues();
  const { isPWA } = useIsPWA();

  const [userIdSetBefore, setUserIdSetBefore] = React.useState(false);

  React.useEffect(() => {
    pushInstruction('enableLinkTracking', false);
    pushInstruction('enableHeartBeatTimer', 10);

    if (user?.trackingId && !userIdSetBefore) {
      pushInstruction('setUserId', user.trackingId);
      setUserIdSetBefore(true);
    } else if (!user?.trackingId && userIdSetBefore) {
      pushInstruction('resetUserId');
      setUserIdSetBefore(false);
    }
  }, [user?.trackingId, userIdSetBefore]);

  React.useEffect(() => {
    pushInstruction(
      'setCustomDimension',
      matomoCustomDimensions['progressiveWebAppStandalone'],
      `${isPWA}`,
    );
  }, [isPWA, matomoCustomDimensions]);

  React.useEffect(() => {
    tracker.pageView(window.document.title, window.location.href);
  }, [location]);

  React.useEffect(() => {
    if (searchTerm.length > 0 && searchResults !== undefined) {
      trackSiteSearch({
        keyword: searchTerm,
        category: 'search',
        count:
          searchResults.contentTypes.length +
          searchResults.genres.length +
          searchResults.languageIntensities.length +
          searchResults.speakers.length +
          searchResults.stories.length +
          searchResults.tags.length,
      });
    }
  }, [searchTerm, searchResults]);

  return null;
};

export default MatomoTracker;
